import { ButtonText } from "@diana-ui/typography";
import styled from "styled-components";
export var StyledButton = /*#__PURE__*/ styled.button.withConfig({
  displayName: "Buttonstyle__StyledButton"
})([
  "color:blue;cursor:pointer;outline-style:none;display:flex;align-items:center;justify-content:center;"
]);
export var StyledButtonText = /*#__PURE__*/ styled(ButtonText).withConfig({
  displayName: "Buttonstyle__StyledButtonText"
})([""]);
